<template>
    <div
    class="o-modal-backdrop"
    @click.self="close"
    v-if="modalOpen"
  >
    <div class="o-modal" @click.stop>
      <span class="o-modal-close" @click="close">
        &times;
      </span>
      <div class="mb-4">
        Please fill in your details, one of our experts will contact you
        shortly.
      </div>
      <div class="mb-4">
        <label>Country</label>
        <select class="form-select" v-model="country" :disabled="loading">
          <option
            v-for="country in countries"
            :key="country"
            :value="country.name"
            >{{ country.name }}</option
          >
        </select>
        <div class="form-check mt-4" v-if="usaMessage">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="isAcreditedUser"
          />
          <label class="form-check-label">
            I am an
            <a
              href="https://www.ecfr.gov/current/title-17/chapter-II/part-230/subject-group-ECFR6e651a4c86c0174/section-230.501"
              target="_blank"
              >accredited investor</a
            >
          </label>
        </div>
        <div class="o-modal-message px-1" v-if="usaMessage">
          {{ usaMessage }}
        </div>
      </div>
      <div class="mb-4">
        <label>Name</label>
        <input
          type="text"
          class="form-control"
          v-model="name"
          :disabled="loading"
        />
      </div>
      <div class="mb-4">
        <label>E-mail</label>
        <input
          type="email"
          class="form-control"
          v-model="email"
          :disabled="loading"
        />
      </div>
      <div class="mb-4">
        <label>Phone number</label>
        <input
          type="phone"
          class="form-control"
          v-model="phone"
          :disabled="loading"
        />
      </div>
      <div class="mb-4">
        <label>The Amount you consider investing</label>
        <input
          type="number"
          class="form-control"
          v-model="investment"
          :disabled="loading"
        />
      </div>
      <div class="mb-4">
        <label>Linkedin Profile</label>
        <input
          type="text"
          class="form-control"
          v-model="linkedin"
          :disabled="loading"
        />
      </div>
      <button
        class="btn btn-lg btn-primary w-100"
        :disabled="!isFormValid"
        @click="submit"
      >
        <span v-if="loading">Sending...</span>
        <span v-else>Submit</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalOpen: false,
      name: "",
      email: "",
      phone: "",
      investment: "",
      country: "",
      isAcreditedUser: false,
      loading: false
    };
  },
  computed: {
    countries() {
      return [
        { name: "United States" },
        { name: "United Kingdom" },
        { name: "Canada" },
        { name: "Afghanistan" },
        { name: "Albania" },
        { name: "Algeria" },
        { name: "American Samoa" },
        { name: "Andorra" },
        { name: "Angola" },
        { name: "Anguilla" },
        { name: "Antigua and Barbuda" },
        { name: "Argentina" },
        { name: "Armenia" },
        { name: "Aruba" },
        { name: "Ascension Island" },
        { name: "Australia" },
        { name: "Austria" },
        { name: "Azerbaijan" },
        { name: "Bahamas" },
        { name: "Bahrain" },
        { name: "Bangladesh" },
        { name: "Barbados" },
        { name: "Belarus" },
        { name: "Belgium" },
        { name: "Belize" },
        { name: "Benin" },
        { name: "Bermuda" },
        { name: "Bhutan" },
        { name: "Bolivia" },
        { name: "Bosnia and Herzegovina" },
        { name: "Botswana" },
        { name: "Brazil" },
        { name: "British Indian Ocean Territory" },
        { name: "British Virgin Islands" },
        { name: "Brunei" },
        { name: "Bulgaria" },
        { name: "Burkina Faso" },
        { name: "Burundi" },
        { name: "Cambodia" },
        { name: "Cameroon" },
        { name: "Cape Verde" },
        { name: "Caribbean Netherlands" },
        { name: "Cayman Islands" },
        { name: "Central African Republic" },
        { name: "Chad" },
        { name: "Chile" },
        { name: "China" },
        { name: "Christmas Island" },
        { name: "Cocos Islands" },
        { name: "Colombia" },
        { name: "Comoros" },
        { name: "Congo" },
        { name: "Congo (Republic)" },
        { name: "Cook Islands" },
        { name: "Costa Rica" },
        { name: "Côte d’Ivoire" },
        { name: "Croatia" },
        { name: "Cuba" },
        { name: "Curaçao" },
        { name: "Cyprus" },
        { name: "Czech Republic" },
        { name: "Denmark" },
        { name: "Djibouti" },
        { name: "Dominica" },
        { name: "Dominican Republic" },
        { name: "Ecuador" },
        { name: "Egypt" },
        { name: "El Salvador" },
        { name: "Equatorial Guinea" },
        { name: "Eritrea" },
        { name: "Estonia" },
        { name: "Eswatini" },
        { name: "Ethiopia" },
        { name: "Falkland Islands" },
        { name: "Faroe Islands" },
        { name: "Fiji" },
        { name: "Finland" },
        { name: "France" },
        { name: "French Guiana" },
        { name: "French Polynesia" },
        { name: "Gabon" },
        { name: "Gambia" },
        { name: "Georgia" },
        { name: "Germany" },
        { name: "Ghana" },
        { name: "Gibraltar" },
        { name: "Greece" },
        { name: "Greenland" },
        { name: "Grenada" },
        { name: "Guadeloupe" },
        { name: "Guam" },
        { name: "Guatemala" },
        { name: "Guernsey" },
        { name: "Guinea" },
        { name: "Guinea-Bissau" },
        { name: "Guyana" },
        { name: "Haiti" },
        { name: "Honduras" },
        { name: "Hong Kong" },
        { name: "Hungary" },
        { name: "Iceland" },
        { name: "India" },
        { name: "Indonesia" },
        { name: "Iran" },
        { name: "Iraq" },
        { name: "Ireland" },
        { name: "Isle of Man" },
        { name: "Israel" },
        { name: "Italy" },
        { name: "Jamaica" },
        { name: "Japan" },
        { name: "Jersey" },
        { name: "Jordan" },
        { name: "Kazakhstan" },
        { name: "Kenya" },
        { name: "Kiribati" },
        { name: "Kosovo" },
        { name: "Kuwait" },
        { name: "Kyrgyzstan" },
        { name: "Laos" },
        { name: "Latvia" },
        { name: "Lebanon" },
        { name: "Lesotho" },
        { name: "Liberia" },
        { name: "Libya" },
        { name: "Liechtenstein" },
        { name: "Lithuania" },
        { name: "Luxembourg" },
        { name: "Macau" },
        { name: "Macedonia" },
        { name: "Madagascar" },
        { name: "Malawi" },
        { name: "Malaysia" },
        { name: "Maldives" },
        { name: "Mali" },
        { name: "Malta" },
        { name: "Marshall Islands" },
        { name: "Martinique" },
        { name: "Mauritania" },
        { name: "Mauritius" },
        { name: "Mayotte" },
        { name: "Mexico" },
        { name: "Micronesia" },
        { name: "Moldova" },
        { name: "Monaco" },
        { name: "Mongolia" },
        { name: "Montenegro" },
        { name: "Montserrat" },
        { name: "Morocco" },
        { name: "Mozambique" },
        { name: "Myanmar" },
        { name: "Namibia" },
        { name: "Nauru" },
        { name: "Nepal" },
        { name: "Netherlands" },
        { name: "New Caledonia" },
        { name: "New Zealand" },
        { name: "Nicaragua" },
        { name: "Niger" },
        { name: "Nigeria" },
        { name: "Niue" },
        { name: "Norfolk Island" },
        { name: "North Korea" },
        { name: "Northern Mariana Islands" },
        { name: "Norway" },
        { name: "Oman" },
        { name: "Pakistan" },
        { name: "Palau" },
        { name: "Palestine" },
        { name: "Panama" },
        { name: "Papua New Guinea" },
        { name: "Paraguay" },
        { name: "Peru" },
        { name: "Philippines" },
        { name: "Poland" },
        { name: "Portugal" },
        { name: "Puerto Rico" },
        { name: "Qatar" },
        { name: "Réunion" },
        { name: "Romania" },
        { name: "Russia" },
        { name: "Rwanda" },
        { name: "Saint Barthélemy" },
        { name: "Saint Helena" },
        { name: "Saint Kitts and Nevis" },
        { name: "Saint Lucia" },
        { name: "Saint Martin" },
        { name: "Saint Pierre and Miquelon" },
        { name: "Saint Vincent and the Grenadines" },
        { name: "Samoa" },
        { name: "San Marino" },
        { name: "São Tomé and Príncipe" },
        { name: "Saudi Arabia" },
        { name: "Senegal" },
        { name: "Serbia" },
        { name: "Seychelles" },
        { name: "Sierra Leone" },
        { name: "Singapore" },
        { name: "Sint Maarten" },
        { name: "Slovakia" },
        { name: "Slovenia" },
        { name: "Solomon Islands" },
        { name: "Somalia" },
        { name: "South Africa" },
        { name: "South Korea" },
        { name: "South Sudan" },
        { name: "Spain" },
        { name: "Sri Lanka" },
        { name: "Sudan" },
        { name: "Suriname" },
        { name: "Svalbard and Jan Mayen" },
        { name: "Sweden" },
        { name: "Switzerland" },
        { name: "Syria" },
        { name: "Taiwan" },
        { name: "Tajikistan" },
        { name: "Tanzania" },
        { name: "Thailand" },
        { name: "Timor-Leste" },
        { name: "Togo" },
        { name: "Tokelau" },
        { name: "Tonga" },
        { name: "Trinidad and Tobago" },
        { name: "Tunisia" },
        { name: "Turkey" },
        { name: "Turkmenistan" },
        { name: "Turks and Caicos Islands" },
        { name: "Tuvalu" },
        { name: "U.S. Virgin Islands" },
        { name: "Uganda" },
        { name: "Ukraine (Україна)" },
        { name: "United Arab Emirates" },
        { name: "Uruguay" },
        { name: "Uzbekistan" },
        { name: "Vanuatu" },
        { name: "Vatican City" },
        { name: "Venezuela" },
        { name: "Vietnam" },
        { name: "Wallis and Futuna" },
        { name: "Western Sahara" },
        { name: "Yemen" },
        { name: "Zambia" },
        { name: "Zimbabwe" },
        { name: "Åland Islands" },
      ];
    },
    usaMessage() {
      if (["United States", "Canada"].includes(this.country)) {
        return "In the United States and Canada, this opportunity is only open to 'accredited investors', which includes persons with net worth over one million dollars or annual income over $200,000";
      }
      return "";
    },
    isFormValid() {
      if (this.loading) return false;
      if (this.usaMessage && !this.isAcreditedUser) return false;
      return (
        this.name.trim() !== "" &&
        this.email.trim() !== "" &&
        this.phone.trim() !== ""
      );
    },
  },
  methods: {
    submit() {
      let url = "https://www.ooyyo.com/ooyyo-services/resources/mail/contact";
      this.loading = true;
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: this.name,
          message:
            `I am interested in investment (${this.investment}). 
            My phone number is: ${this.phone}. My LinkedIn is ${this.linkedin}`,
          email: this.email,
          subject: "INVESTMENT",
        }),
      })
        .then((data) => data.json())
        .then((data) => {
          console.log(data);
          this.name = "";
          this.email = "";
          this.phone = "";
          this.investment = "";
          this.linkedin = "";
          alert("Message successfully sent.");
        })
        .catch((err) => {
          console.log(err);
          alert("Something went wrong");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open() {
      document.querySelector("body").classList.add("modal-open");
      this.modalOpen = true;
    },
    close() {
      document.querySelector("body").classList.remove("modal-open");
      this.modalOpen = false;
    },
  },
};
</script>